export const SET_CURRENT_CLIENT = "SET_CURRENT_CLIENT";

export const REMOVE_CURRENT_CLIENT = "REMOVE_CURRENT_CLIENT";

export const SET_REVENUE_REPORT_TEMPLATE_DATA = "SET_REVENUE_REPORT_TEMPLATE_DATA";

export const SET_XML_DOWNLOAD_LINK = "SET_XML_DOWNLOAD_LINK";
